import { render, staticRenderFns } from "./entity-row.vue?vue&type=template&id=4d2a2e3e&scoped=true"
import script from "./entity-row.vue?vue&type=script&lang=ts"
export * from "./entity-row.vue?vue&type=script&lang=ts"
import style0 from "./entity-row.vue?vue&type=style&index=0&id=4d2a2e3e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d2a2e3e",
  null
  
)

export default component.exports